import { Injectable, inject, signal } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { APP_ROUTES } from '@app/constants';
import { MenuItem } from 'primeng/api';
import { filter } from 'rxjs';

const initialBreadcumb = [
  {
    label: 'Dashboard',
    routerLink: APP_ROUTES.DASHBOARD,
  },
];

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  private router = inject(Router);

  private breadcrumbs = signal<MenuItem[]>(initialBreadcumb);
  private home = signal<MenuItem>({
    icon: 'pi pi-home',
    routerLink: APP_ROUTES.DASHBOARD,
  });

  constructor() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        const root = this.router.routerState.snapshot.root;
        const breadcrumbs: MenuItem[] = [];
        this.addBreadcrumb(root, [], breadcrumbs);

        const filteredBreadcrumbs = breadcrumbs.filter((d) => d.label);

        if (filteredBreadcrumbs.length === 0) {
          this.setBreadcrumbs(initialBreadcumb);
        } else {
          this.setBreadcrumbs(filteredBreadcrumbs);
        }
      });
  }

  private addBreadcrumb(
    route: ActivatedRouteSnapshot,
    parentUrl: string[],
    breadcrumbs: MenuItem[]
  ) {
    if (route) {
      // Construct the route URL
      const routeUrl = parentUrl.concat(route.url.map((url) => url.path));

      // Add an element for the current route part
      if (route.data['breadcrumb']) {
        const breadcrumb = {
          label: route.data['breadcrumb']?.label ?? '',
          routerLink: routeUrl,
        };
        breadcrumbs.push(breadcrumb);
      }

      // Add another element for the next route part
      this.addBreadcrumb(
        route.firstChild as ActivatedRouteSnapshot,
        routeUrl,
        breadcrumbs
      );
    }
  }

  getBreadcrumbs() {
    return this.breadcrumbs;
  }

  getHome() {
    return this.home;
  }

  setBreadcrumbs(breadcrumbs: MenuItem[]) {
    this.breadcrumbs.set(breadcrumbs);
  }

  setHome(home: MenuItem) {
    this.home.set(home);
  }
}
